// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-warning-light[data-v-820e1c6c]{background-color:#ffe9a4}", ""]);
// Exports
module.exports = exports;
